// Minimal store-only (no compression) ZIP builder — enough to bundle a handful of small CSV
// templates without adding a zip dependency. Returns a Blob. Store method + CRC32; correct local
// headers, central directory and EOCD so any unzip tool opens it.
const crcTable = (() => {
    const t = new Uint32Array(256);
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        t[n] = c >>> 0;
    }
    return t;
})();

const crc32 = (bytes) => {
    let c = 0xffffffff;
    for (let i = 0; i < bytes.length; i++) c = crcTable[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
    return (c ^ 0xffffffff) >>> 0;
};

// files: [{ name, content }]  (content is a UTF-8 string)
export const zipFiles = (files) => {
    const enc = new TextEncoder();
    const parts = [];
    const central = [];
    let offset = 0;

    for (const f of files) {
        const nameBytes = enc.encode(f.name);
        const data = enc.encode(f.content);
        const crc = crc32(data);

        const local = new DataView(new ArrayBuffer(30));
        local.setUint32(0, 0x04034b50, true); // local file header sig
        local.setUint16(4, 20, true);         // version needed
        local.setUint16(6, 0, true);          // flags
        local.setUint16(8, 0, true);          // method: store
        local.setUint16(10, 0, true);         // mod time
        local.setUint16(12, 0, true);         // mod date
        local.setUint32(14, crc, true);
        local.setUint32(18, data.length, true); // compressed size
        local.setUint32(22, data.length, true); // uncompressed size
        local.setUint16(26, nameBytes.length, true);
        local.setUint16(28, 0, true);         // extra len
        parts.push(new Uint8Array(local.buffer), nameBytes, data);

        const cd = new DataView(new ArrayBuffer(46));
        cd.setUint32(0, 0x02014b50, true);    // central dir header sig
        cd.setUint16(4, 20, true);            // version made by
        cd.setUint16(6, 20, true);            // version needed
        cd.setUint16(8, 0, true);
        cd.setUint16(10, 0, true);            // method: store
        cd.setUint16(12, 0, true);
        cd.setUint16(14, 0, true);
        cd.setUint32(16, crc, true);
        cd.setUint32(20, data.length, true);
        cd.setUint32(24, data.length, true);
        cd.setUint16(28, nameBytes.length, true);
        cd.setUint16(30, 0, true);            // extra
        cd.setUint16(32, 0, true);            // comment
        cd.setUint16(34, 0, true);            // disk number
        cd.setUint16(36, 0, true);            // internal attrs
        cd.setUint32(38, 0, true);            // external attrs
        cd.setUint32(42, offset, true);       // local header offset
        central.push(new Uint8Array(cd.buffer), nameBytes);

        offset += 30 + nameBytes.length + data.length;
    }

    const cdSize = central.reduce((s, c) => s + c.length, 0);
    const eocd = new DataView(new ArrayBuffer(22));
    eocd.setUint32(0, 0x06054b50, true);      // end of central dir sig
    eocd.setUint16(4, 0, true);               // disk number
    eocd.setUint16(6, 0, true);               // cd start disk
    eocd.setUint16(8, files.length, true);    // entries this disk
    eocd.setUint16(10, files.length, true);   // total entries
    eocd.setUint32(12, cdSize, true);
    eocd.setUint32(16, offset, true);         // cd offset
    eocd.setUint16(20, 0, true);              // comment len

    return new Blob([...parts, ...central, new Uint8Array(eocd.buffer)], { type: "application/zip" });
};
